/**
 * @param {any} args The argument you're trying to inspect
 * @returns {Boolean} Return true if argument is an Object
 */
export function isObject(args: any): args is {} {
  return Object.prototype.toString.call(args) === '[object Object]';
}
